import React from "react";
import { StaticPromptsProps } from "../types";
import { t } from "i18next";

const StaticPrompts: React.FC<StaticPromptsProps> = ({
  questions,
  handleSendMessage,
  tenantName,
}) => {
  const handlePromptClick = (prompt: string) => {
    handleSendMessage(prompt);
  };

  return (
    <div className="flex flex-col items-center justify-center my-12 space-y-6 px-4">
      <div className="text-center">
        <h3 className="text-xl font-medium text-primary mb-2">
        🤖 {t("start_new_conversation_with") as string} {tenantName} 🤖
        </h3>
        <p className="text-zinc-500 mb-8 text-sm sm:text-base">
          {t("select_prompt_or_type") as string}
        </p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-2 gap-3 w-full max-w-3xl">
        {questions.map((prompt, index) => (
          <button
            key={index}
            className="relative w-full text-center px-2 py-1 sm:p-4 rounded-full transition-shadow shadow-sm hover:shadow-md group overflow-hidden"
            onClick={() => handlePromptClick(prompt)}
          >
            {/* Gradient Border Layer */}
            <div className="absolute inset-0 bg-gradient-to-r from-indigo-500 to-purple-500 rounded-full z-0" />

            {/* Inner White Background */}
            <div className="absolute inset-[1px] bg-white rounded-full z-10" />

            {/* Content Layer */}
            <div className="relative z-20">
              <h4 className="font-medium text-zinc-900 text-xs sm:text-base">
                {prompt}
              </h4>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default StaticPrompts;
